import { render, staticRenderFns } from "./DetailsSources.vue?vue&type=template&id=e973ed70&scoped=true&"
import script from "./DetailsSources.vue?vue&type=script&lang=js&"
export * from "./DetailsSources.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSources.vue?vue&type=style&index=0&id=e973ed70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e973ed70",
  null
  
)

export default component.exports